import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import { Translate } from 'react-localize-redux';

import { Button, Typography } from '@fd/ui/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  container: {
    alignItems: 'center',
    borderTop: `1px dashed ${theme.palette.grey[600]}`,
    backgroundColor: '#EAF2FF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(3, -3, -3, -3),
    padding: theme.spacing(1, 3, 3, 3),
  },
  rejectButton: {
    backgroundColor: '#CA0030',
    marginRight: theme.spacing(3),
    '&:hover': {
      backgroundColor: '#8F0022',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(2),
      marginRight: 0,
    },
  },
}));

export type InternalReviewControlsProps = {
  onPass: () => void;
  onReject: () => void;
};

export const InternalReviewControls = ({ onPass, onReject }: InternalReviewControlsProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="caption">
        <Translate id="Access_only_for_flipdishers_description" />
      </Typography>
      <div className={classes.buttonContainer}>
        <Button className={classes.rejectButton} fdKey="reject-button" fullWidth onClick={onReject}>
          {/* <Translate id="Reject_submission" /> */}
          Reject submission
        </Button>
        <Button fdKey="pass-button" fullWidth onClick={onPass}>
          {/* <Translate id="Pass_review" /> */}
          Pass review
        </Button>
      </div>
    </div>
  );
};
